import { auth, LOCAL, realtimeDB, TIMESTAMP, firestore } from "../_firebase";
import Collection from "../_collections";
import { forEach, kebabCase } from "lodash";

const getMaritalStatus = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.MARITAL_STATUS)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const getMotherTongue = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.MOTHER_TONGUE)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const getBodyType = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.BODY_TYPE)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const getComplexion = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.COMPLEXION)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const getDiet = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.DIET)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const getHabitType = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.HABIT_TYPE)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const getJobType = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.JOB_TYPE)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const getIncome = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.INCOME)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const getEducation = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.EDUCATION)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const getEmployedIn = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.EMPLOYED_IN)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const getReligion = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.RELIGION)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const getCommunity = religion => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.RELIGION)
      .doc(religion)
      .collection(Collection.COMMUNITY)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const createCommunity = (religion, community) => {
  let promise = new Promise((resolve, reject) => {
    if (!religion) {
      reject("No Religion");
    }
    if (!community) {
      reject("No Community");
    }
    firestore
      .collection(Collection.RELIGION)
      .doc(religion.value)
      .collection(Collection.COMMUNITY)
      .doc(kebabCase(community.value))
      .set({
        label: community.value,
        value: kebabCase(community.value),
        description: community.value
      })
      .then(collection => {
        resolve({
          label: community.value,
          value: kebabCase(community.value),
          description: community.value
        });
      })
      .catch(err => {
        console.log(err);
        reject(null);
      });
  });
  return promise;
};
const getCaste = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.CASTE)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const getHeight = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.HEIGHT)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const getDisability = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.DISABILITY)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const getFamilyStatus = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.FAMILY_STATUS)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const getFamilyValue = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.FAMILY_VALUE)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const getFamilyType = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.FAMILY_TYPE)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const getHouseType = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.HOUSE_TYPE)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const getMoonSign = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.MOON_SIGN)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const getCreatedBy = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.CREATED_BY)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};
const getCountry = () => {
  let promise = new Promise((resolve, reject) => {
    firestore
      .collection(Collection.COUNTRY)
      .get()
      .then(collection => {
        const data = [];
        collection.forEach(item => {
          data.push(item.data());
        });
        resolve(data);
      })
      .catch(err => {
        reject([]);
      });
  });
  return promise;
};

const getState = countries => {
  let promises = [];
  forEach(countries, country => {
    promises.push(
      firestore
        .collection(Collection.COUNTRY)
        .doc(country.label)
        .collection(Collection.STATE)
        .get()
    );
  });

  return Promise.all(promises)
    .then(responses => {
      let results = [];
      forEach(responses, response => {
        response.forEach(item => {
          results.push(item.data());
        });
      });
      return results;
    })
    .catch(err => {
      return Promise.reject(err);
    });
};

const dataService = {
  getMaritalStatus,
  getMotherTongue,
  getBodyType,
  getComplexion,
  getDiet,
  getHabitType,
  getJobType,
  getIncome,
  getEducation,
  getEmployedIn,
  getReligion,
  getCommunity,
  createCommunity,
  getCaste,
  getHeight,
  getDisability,
  getFamilyStatus,
  getFamilyValue,
  getFamilyType,
  getHouseType,
  getMoonSign,
  getCreatedBy,
  getCountry,
  getState
};
export default dataService;



// WEBPACK FOOTER //
// ./src/_services/dataService.js